import {
    Banknote,
    CreditCard,
    Euro,
} from 'lucide-react';

export const FINANCING_TYPES = [
    { value: 'cash', label: 'Comptant', icon: Banknote },
    { value: 'credit', label: 'Crédit immobilier', icon: CreditCard },
    { value: 'mixte', label: 'Mixte (apport + crédit)', icon: Euro }
];

export const DEFAULT_CONDITIONS = [
    "Obtention d'un prêt immobilier aux conditions du marché",
    "Absence de servitudes d'urbanisme ou d'utilité publique",
    "Obtention d'un permis de construire ou d'une autorisation de travaux",
    "État des risques et pollutions satisfaisant"
];

export const EMPTY_BUYER = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    postal_code: '',
};

export const EMPTY_FORM = {
    mandate_id: '',
    offer_amount: '',
    validity_days: 10,
    desired_signature_date: '',
    personal_message: '',
    buyers: [{ ...EMPTY_BUYER }],
    financing: {
        type: 'credit',
        personal_contribution: '',
        loan_amount: '',
        loan_duration_months: 240,
        has_pre_approval: false,
        bank_name: '',
    },
    conditions: ["Obtention d'un prêt immobilier aux conditions du marché"],
};

export const formatPrice = (price) => {
    if (!price) return '';
    return new Intl.NumberFormat('fr-FR').format(price);
};
